/* eslint-disable import/prefer-default-export */
// const mailFormat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
const mailFormat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // width "+"

export const isEmail = (email) => mailFormat.test(email);
